import React from 'react';
import { Button } from '../../ui/button';
import { ArrowLeft, ChevronLeft, ChevronRight, Calendar, Mic, Loader2 } from 'lucide-react';

export function NutritionHeader({
  selectedDate,
  onBack,
  onPrevDay,
  onNextDay,
  onGoToToday,
  voiceFood,
}) {
  const today = new Date().toISOString().split('T')[0];
  const isToday = selectedDate === today;
  
  const formatDisplayDate = (dateStr) => {
    const date = new Date(dateStr);
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (isToday) return 'Today';
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (dateStr === yesterday.toISOString().split('T')[0]) return 'Yesterday';
    return `${dayNames[date.getDay()]}, ${monthNames[date.getMonth()]} ${date.getDate()}`;
  };

  return (
    <header className="sticky top-0 z-40 bg-slate-950/95 backdrop-blur-sm border-none ios-header" style={{ border: 'none' }}>
      <div className="flex items-center justify-between px-4 py-3">
        {/* Back Button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          className="text-slate-400 hover:text-white"
          data-testid="nutrition-back-btn"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>

        {/* Date Navigation */}
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" onClick={onPrevDay} className="text-slate-400 hover:text-white h-8 w-8">
            <ChevronLeft className="h-5 w-5" />
          </Button>
          <button
            onClick={onGoToToday}
            className={`px-2 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              isToday ? 'bg-blue-500/20 text-blue-400' : 'text-white hover:bg-slate-800'
            }`}
          >
            {formatDisplayDate(selectedDate)}
          </button>
          <Button variant="ghost" size="icon" onClick={onNextDay} disabled={isToday} className="text-slate-400 hover:text-white h-8 w-8 disabled:opacity-30">
            <ChevronRight className="h-5 w-5" />
          </Button>
        </div>

        {/* Right side: Language + Mic + Today */}
        <div className="flex items-center gap-1">
          {voiceFood && (
            <>
              <select
                value={voiceFood.language}
                onChange={(e) => voiceFood.setLanguage(e.target.value)}
                className="bg-slate-700 text-slate-300 text-xs rounded px-1.5 py-1 border-0 outline-none h-8"
                data-testid="voice-language-select"
              >
                {voiceFood.languages.map(l => (
                  <option key={l.code} value={l.code}>{l.label}</option>
                ))}
              </select>
              <button
                onClick={voiceFood.isRecording ? voiceFood.stopRecording : voiceFood.startRecording}
                disabled={voiceFood.isProcessing}
                className={`h-8 w-8 rounded-full flex items-center justify-center transition-all ${
                  voiceFood.isProcessing
                    ? 'bg-slate-600 cursor-wait'
                    : voiceFood.isRecording
                    ? 'bg-red-500 animate-pulse'
                    : 'bg-purple-500/80 hover:bg-purple-500'
                }`}
                data-testid="voice-mic-btn"
              >
                {voiceFood.isProcessing ? (
                  <Loader2 className="h-4 w-4 text-white animate-spin" />
                ) : (
                  <Mic className="h-4 w-4 text-white" />
                )}
              </button>
            </>
          )}
          {!isToday && (
            <Button variant="ghost" size="sm" onClick={onGoToToday} className="text-blue-400 hover:text-blue-300 ml-1">
              <Calendar className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

export default NutritionHeader;
